import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"
import { AuthProvider, RequireAuth } from "@/auth/AuthProvider"
import { MainLayout } from "@/components/layout/MainLayout"
import { ToastProvider } from "@/components/Toast"
import { LoginPage } from "@/pages/LoginPage"
import { OrganisationenPage } from "@/pages/OrganisationenPage"
import { OrganisationDetailPage } from "@/pages/OrganisationDetailPage"
import { KontaktePage } from "@/pages/KontaktePage"
import { ZertifikatePage } from "@/pages/ZertifikatePage"
import { ArtikelPage } from "@/pages/ArtikelPage"
import { FinanzenPage } from "@/pages/FinanzenPage"
import { LieferbedingungenPage } from "@/pages/LieferbedingungenPage"
import { PflegePage } from "@/pages/PflegePage"
import { SettingsPage } from "@/pages/SettingsPage"

const queryClient = new QueryClient()

// Leerer Callback-Screen: LogtoGate (im AuthProvider) rendert waehrend
// /callback selbst die CallbackPage (Token-Tausch), diese Route existiert
// nur, damit react-router den Pfad kennt und nicht auf "*" faellt.
function CallbackRoute() {
  return null
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        {/* AuthProvider muss INNERHALB des BrowserRouter haengen (nutzt useLocation/useNavigate) */}
        <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, "")}>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/callback" element={<CallbackRoute />} />
              <Route
                element={
                  <RequireAuth>
                    <MainLayout />
                  </RequireAuth>
                }
              >
                <Route path="/organisationen" element={<OrganisationenPage />} />
                <Route path="/organisationen/:id" element={<OrganisationDetailPage />} />
                <Route path="/kontakte" element={<KontaktePage />} />
                <Route path="/zertifikate" element={<ZertifikatePage />} />
                <Route path="/artikel" element={<ArtikelPage />} />
                <Route path="/lieferbedingungen" element={<LieferbedingungenPage />} />
                <Route path="/pflege/*" element={<PflegePage />} />
                <Route path="/finanzen" element={<FinanzenPage />} />
                <Route path="/einstellungen" element={<SettingsPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/organisationen" replace />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  )
}
